import { h as __h } from "preact";
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import { pluralize } from "~/util/pluralize.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string }} props
 * @param {string[]} machine_ids
 */
export const deleteComputers = async ({
  orgId
}, ...machine_ids) => {
  const res = await confirmModal({
    title: `Remove ${machine_ids.length} ${pluralize(machine_ids.length, "computer")}?`,
    action: "Remove",
    body: __h("p", {}, "To re-add this computer, you will need to reinstall Phaze using a machine key.")
  });
  if (!res) return;
  try {
    await authedApiRequest("DELETE", `/v2/orgs/${orgId}/machines`, {
      json: {
        machine_ids
      }
    });
    Query.invalidate([`/ui/admin/orgs/${orgId}/machines`], ...machine_ids.map(id => [`/ui/admin/orgs/${orgId}/machines/${id}`]), [`/ui/admin/orgs/${orgId}/members`], [`/v2/orgs/${orgId}/groups`], [`/v2/orgs/${orgId}/locations`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};